var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJigsFixturesDesign(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 1.25H7.25V2.75H17V1.25Z",
    fill: "#E69135"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9485 10.2485C17.2385 8.8235 16.25 6.713 16.25 4.487V3.5H8V4.487C8 6.713 7.0115 8.8235 5.3015 10.2485L3.5 11.75L11.75 23.75V15.4625C10.8942 15.2885 10.25 14.5325 10.25 13.625C10.25 12.5892 11.0892 11.75 12.125 11.75C13.1608 11.75 14 12.5892 14 13.625C14 14.5317 13.3558 15.2885 12.5 15.4625V23.75L20.75 11.75L18.9485 10.2485Z",
    fill: "#E69135"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17 1.25H7.25V2.75H17V1.25Z",
    fill: "#E69135"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9485 10.2485C17.2385 8.8235 16.25 6.713 16.25 4.487V3.5H8V4.487C8 6.713 7.0115 8.8235 5.3015 10.2485L3.5 11.75L11.75 23.75V15.4625C10.8942 15.2885 10.25 14.5325 10.25 13.625C10.25 12.5892 11.0892 11.75 12.125 11.75C13.1608 11.75 14 12.5892 14 13.625C14 14.5317 13.3558 15.2885 12.5 15.4625V23.75L20.75 11.75L18.9485 10.2485Z",
    fill: "#E69135"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJigsFixturesDesign);
export default __webpack_public_path__ + "static/media/jigs-fixtures-design.874a11666492df519309876ea0bdc4f3.svg";
export { ForwardRef as ReactComponent };